export enum FeatureToggle {
  retailerFundedMarketing = 'rt_retailer_funded_marketing',
  retailerFundedMarketingCampaign = 'rt_retailer_funded_marketing_campaign',
  retailerFundedMarketingPhase4 = 'rt_retailer_funded_marketing_phase4',
  retailerFundedMarketingPercentageOff = 'rt_retailer_funded_marketing_percentage_off',
  growBasketSizeTemplate = 'rt_rfm_grow_basket_sizes_template',
  icmsNewAndChurnedCustomersTemplate = 'rt_rfm_icms_new_and_churned_customers_template',
  alcoholBasedOfferOption = 'rt_rfm_alcohol_based_offer_option',
  InsightsCampaignAnalytics = 'rt_insights_campaign_insights',
  InsightsCampaignInsightsDisabledRetailers = 'rt_insights_campaign_insights_disabled_retailers',
  campaignsV2Enabled = 'rt_campaigns_v2_enabled',
  campaignsV2TemplateAwarenessEnabled = 'rt_campaigns_v2_template_awareness_enabled',
  campaignsV2TemplateEmailEnabled = 'rt_campaigns_v2_template_email_enabled',
  campaignsV2TemplateSearchEnabled = 'rt_campaigns_v2_template_search_enabled',
  campaignsV2TemplateGrowBasketSizes = 'rt_campaigns_v2_template_grow_basket_sizes',
  campaignsV2TemplateOfferEnabled = 'rt_campaigns_v2_template_offer_enabled',
  crmCampaignManualOverrides = 'rt_crm_campaign_manual_overrides',
  campaignV2TemplateMomentEnabled = 'rt_campaigns_v2_template_moment_enabled',
  retailerFundedMarketingUserDenyList = 'rt_rfm_user_deny_list',
  campaignsV2TemplateAcquisition = 'rt_campaigns_v2_template_acquisition',
  campaignsV2TemplateAudienceTargeting = 'rt_campaigns_v2_template_audience_targeting',
  campaignsCrmPushEnabled = 'rt_campaigns_crm_push_enabled',
  segmentationTargetingEmailCSVEnabled = 'rt_campaign_targeting_email_csv',
  customCampaignEnabled = 'rt_campaigns_custom_campaign_enabled',
  useCrmsForCrmCampaign = 'rt_use_crms_for_crm_campaign',
  offersProductDiscountsEnabled = 'rt_offers_product_discounts',
  offersFreeDeliveryPickupEnabled = 'rt_offers_free_delivery_pickup',
  copyCampaignsEnabled = 'rt_campaigns_copy_campaign_enabled',
  campaignsDxGyEnabled = 'rt_campaigns_dxgy_integration',
  updateTargetingRules = 'campaign_management_allow_update_targeting_rules',
  enableGlobalSegmentSelectionForRetailerSpecific = 'rt_enable_global_segment_selection_for_retailer_specific_campaigns',
  overrideEnableCopyCampaign = 'rt_override_enable_copy_campaign',
  enableDefineCustomSegment = 'rt_enable_campaign_targeting_rule_builder',
  draftCampaigns = 'rt_draft_campaigns',
  showMarketplaceCampaignsForCostco = 'rt_show_marketplace_campaigns_for_costco',
}
